import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Link, useHistory, withRouter } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import lightLogo from "../../../../img/logo-light.png";
import FetchInvitationLoader from "../dashboard-register-loader";
import { ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import * as EmailValidator from "email-validator";
import { auth } from "../../../../networking/firebase";
import RegisterView from "../register-view";
import { sendErrorNotification } from "../../../universal/notifications/notifications";
import {
  requestCanRegister,
  requestGeneralRegistrationValidation,
  resetGeneralRegistrationValidation,
} from "../../../../redux/actions/registration";

import "react-toastify/dist/ReactToastify.css";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const stripePromise = loadStripe(
    `${process.env.REACT_APP_STRIPE_PUBLIC_KEY}`
  );

  const [passwordStrength, setPasswordStrength] = useState(0);

  const [registrationObject, setRegistrationObject] = useState({
    firstName: null,
    lastName: null,
    email: null,
    mobile: null,
    password: null,
    organizationNumber: null,
  });

  const [termsChecked, setTermsChecked] = useState(false);
  const [referralId, setReferralId] = useState(null);

  const checkCanRegisterLoading = useSelector(
    (state) => state.registration.checkCanRegisterLoading
  );
  const checkCanRegisterError = useSelector(
    (state) => state.registration.checkCanRegisterError
  );
  const checkCanRegisterStatus = useSelector(
    (state) => state.registration.checkCanRegisterStatus
  );

  const validateGeneralLoading = useSelector(
    (state) => state.registration.validateGeneral.loading
  );
  const validateGeneralError = useSelector(
    (state) => state.registration.validateGeneral.error
  );
  const validateGeneralStatus = useSelector(
    (state) => state.registration.validateGeneral.status
  );
  const validateGeneralId = useSelector(
    (state) => state.registration.validateGeneral.id
  );

  const [tabs, _] = useState([
    {
      name: "Kontodetaljer",
      name_mobile: "Detaljer",
      description: "Kort om deg selv",
      icon: <i class="fas fa-user"></i>,
      active: true,
    },
    {
      name: "Start prøveperiode",
      name_mobile: "Prøveperiode",
      description: "Betalingsinformasjon",
      icon: <i class="fad fa-hourglass-start"></i>,
      active: false,
    },
    {
      name: "Kom i gang",
      name_mobile: "Kom i gang",
      description: "Gå til dashboard",
      icon: <i class="fad fa-check-double"></i>,
      active: false,
    },
  ]);

  useEffect(() => {
    if (window.Rewardful.referral) {
      setReferralId(window.Rewardful.referral);
    }
  }, [window.rewardful]);

  const navigateCheckout = async (orgNumber) => {
    try {
      const stripe = await stripePromise;
      const session = await fetch("/api/stripe/create-checkout-session", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          organizationNumber: orgNumber,
          referralId: referralId,
          type: "signup",
          trial: true,
        }),
      });

      const response = await session.json();
      stripe.redirectToCheckout({ sessionId: response.sessionId });
    } catch (e) {
      sendErrorNotification("Kunne ikke fortsette til kassen.");
      dispatch(resetGeneralRegistrationValidation());
    }
  };

  const clickRegister = async () => {
    try {
      if (
        registrationObject.firstName &&
        registrationObject.lastName &&
        registrationObject.email &&
        registrationObject.mobile &&
        registrationObject.password
      ) {
        if (termsChecked) {
          if (EmailValidator.validate(registrationObject.email)) {
            if (passwordStrength > 1) {
              dispatch(
                requestGeneralRegistrationValidation(registrationObject)
              );
            } else {
              sendErrorNotification("Passordet ditt er for svakt.");
            }
          } else {
            sendErrorNotification("E-posten er ikke gyldig.");
          }
        } else {
          sendErrorNotification("Du må akseptere brukervilkårene.");
        }
      } else {
        sendErrorNotification("Vennligst fyll inn alle felt.");
      }
    } catch (e) {
      sendErrorNotification("Kan ikke fullføre registrering.");
    }
  };

  useEffect(() => {
    if (
      validateGeneralStatus &&
      validateGeneralStatus === "success" &&
      validateGeneralId
    ) {
      navigateCheckout(validateGeneralId);
    }
  }, [validateGeneralStatus, validateGeneralId]);

  useEffect(() => {
    if (validateGeneralError) {
      sendErrorNotification(validateGeneralError);
    }
  }, [validateGeneralError]);

  return (
    <section className="first-register-page-section">
      <div className="inner-register-page-container">
        <div className="full-content-container">
          <div className="register-display-container">
            <div className="register-box-container">
              <div className="inner-register-box-container">
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Row className="register-row">
                    <Col md className="menu-col">
                      <Link to="/">
                        <img
                          alt="Leadfind logo"
                          className="menu-logo"
                          src={lightLogo}
                        />
                      </Link>
                      <p className="register-description">
                        Det går fortere enn du tror, registrering tar under ett
                        minutt.
                      </p>
                      <Nav
                        variant="pills"
                        className="flex-column menu-navigation desktop"
                      >
                        {tabs.map((tab) => {
                          return (
                            <Nav.Item>
                              <Nav.Link active={tab.active}>
                                <div
                                  className={`single-step-container ${
                                    tab.active ? "active" : ""
                                  }`}
                                >
                                  <Row className="step-row">
                                    <Col className="icon-col my-auto">
                                      <div className="step-container">
                                        <span className="icon">{tab.icon}</span>
                                      </div>
                                    </Col>
                                    <Col className="data-col my-auto">
                                      <span className="step-title">
                                        {tab.name}
                                      </span>
                                      <span className="step-description">
                                        {tab.description}
                                      </span>
                                    </Col>
                                  </Row>
                                  <span className="active-indicator" />
                                </div>
                              </Nav.Link>
                            </Nav.Item>
                          );
                        })}
                      </Nav>
                      <Nav className="menu-navigation mobile">
                        <Row className="mobile-menu-row">
                          {tabs.map((tab) => {
                            return (
                              <Col
                                className={`outer-step-container text-center ${
                                  tab.active ? "active" : ""
                                }`}
                              >
                                <Col className="inner-step-container">
                                  <div className="icon-container text-center">
                                    <span className="icon">{tab.icon}</span>
                                  </div>
                                  <div className="title-container">
                                    <span className="step-title">
                                      {tab.name_mobile}
                                    </span>
                                  </div>
                                  {tab.active ? (
                                    <div className="separator" />
                                  ) : null}
                                </Col>
                              </Col>
                            );
                          })}
                        </Row>
                      </Nav>
                    </Col>
                    <Col md className="display-col">
                      {checkCanRegisterLoading || validateGeneralLoading ? (
                        <FetchInvitationLoader />
                      ) : null}
                      <div className="inner-tab-container">
                        <RegisterView
                          setRegistrationObject={setRegistrationObject}
                          registrationObject={registrationObject}
                          clickRegister={clickRegister}
                          validateGeneralLoading={validateGeneralLoading}
                          termsChecked={termsChecked}
                          setTermsChecked={setTermsChecked}
                          setPasswordStrength={setPasswordStrength}
                        />
                      </div>
                    </Col>
                  </Row>
                </Tab.Container>
              </div>
            </div>
            <div className="links-container">
              <Link to="/">Leadfind.no</Link>
              <span className="circle-separator">
                <i class="fas fa-circle"></i>
              </span>
              <Link to="/personvern">Personvern</Link>
              <span className="circle-separator">
                <i class="fas fa-circle"></i>
              </span>
              <Link to="/cookies">Cookies</Link>
              <span className="circle-separator">
                <i class="fas fa-circle"></i>
              </span>
              <Link to="/vilkår">Vilkår</Link>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default withRouter(Index);
